
import Vue from 'vue'
import vuetify from './plugins/vuetify';
import app from './App.vue'
import router from './router'

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  render: h => h(app)
}).$mount('#app');

